import { useState } from "react";
import { UserData, setUser } from "../../actions/authentificationActions";
import { Form, Button } from "semantic-ui-react";
import { updateUser } from "../../services/userService";
import { useDispatch } from "react-redux";
import { toast } from "../..";

interface IProps {
    user: UserData;
}

export const EditUserDetails = ({ user }: IProps) => {
    const dispatch = useDispatch();
    const [userDto, setUserDto] = useState(user);
    const [saving, setSaving] = useState(false);
    const isEnabled = userDto.firstName!.length > 0 && userDto.lastName!.length > 0;

    const handleUpdateUser = async () => {
        setSaving(true);
        const res = await updateUser(userDto);
        if (res.status === 200) {
            dispatch(setUser(userDto));
            sessionStorage.setItem("user", JSON.stringify(userDto));
            toast("Successfully updated user details", true);
        } else toast("Error updating user details", false);
        setSaving(false);
    };

    return (
        <div id="user-form-container-userDetails" className="user-form-container">
            <h2 id="h2-userDetails" className="tsc-blue">Edit user details</h2>
            <Form id="form-userDetails" className="user-form">
                <Form.Field id="form-field-userDetails-a">
                    <label id="label-firstName-userDetails">First name</label>
                    <input
                        id="input-userDetails-a"
                        placeholder="First name"
                        defaultValue={user.firstName}
                        onChange={e =>
                            setUserDto({
                                ...userDto,
                                firstName: e.target.value,
                            })
                        }
                    />
                </Form.Field>
                <Form.Field id="form-field-userDetails-b">
                    <label id="label-lastName-userDetails">Last name</label>
                    <input
                        id="input-userDetails-b"
                        placeholder="Last name"
                        defaultValue={user.lastName}
                        onChange={e =>
                            setUserDto({
                                ...userDto,
                                lastName: e.target.value,
                            })
                        }
                    />
                </Form.Field>
            </Form>
            <Button
                id="button-submit-userDetails"
                type="submit"
                onClick={handleUpdateUser}
                content="Save user details"
                primary
                fluid
                disabled={!isEnabled || saving}
                loading={saving}
            />
        </div>
    );
};
